<template>
  <section class="content">
    <h2 class="subtitle">
      Tell Us About Yourself
    </h2>
    <div class="columns is-multiline">
      <div
        v-for="(field, key) in allFields"
        :key="key"
        class="field is-horizontal column is-8 is-marginless"
      >
        <label :for="field.name" class="field-label has-text-weight-bold">
          {{ field.label }}
        </label>
        <div class="field-body" v-if="field.nested">
          <div class="field" v-for="(subfield, key) in field.nested" :key="key">
            <FormHtml :field="subfield" v-if="subfield.type === 'html'"></FormHtml>
            <FormSelect :field="subfield" v-else-if="subfield.type === 'select'"></FormSelect>
            <FormTextArea :field="subfield" v-else-if="subfield.type === 'textarea'"></FormTextArea>
            <FormInput :field="subfield" v-else></FormInput>
          </div>
        </div>
        <div class="field-body" v-else>
          <div class="field">
            <FormHtml :field="field" v-if="field.type === 'html'"></FormHtml>
            <FormSelect :field="field" v-else-if="field.type === 'select'"></FormSelect>
            <FormTextArea :field="field" v-else-if="field.type === 'textarea'"></FormTextArea>
            <FormInput :field="field" v-else></FormInput>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FormInput from '@/components/Form/Input.vue';
import FormSelect from '@/components/Form/Select.vue';
import FormTextArea from '@/components/Form/TextArea.vue';
import FormHtml from '@/components/Form/Html.vue';
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    allFields: 'fields',
  }),
  components: {
    FormInput,
    FormSelect,
    FormTextArea,
    FormHtml,
  },
};
</script>
